import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageSquareQuote } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { Page } from "@/components/Page";

export default function Quotes() {
  const [form, setForm] = useState({ product_name: "", quantity: 1, buyer_name: "", buyer_email: "", notes: "" });
  const [busy, setBusy] = useState(false);
  const [items, setItems] = useState([]);

  const load = () => api.get("/dashboard").then(r => setItems(r.data.quotes || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/quotes", { ...form, quantity: Number(form.quantity) });
      setForm({ product_name: "", quantity: 1, buyer_name: "", buyer_email: "", notes: "" });
      toast.success("Buyer request recorded");
      load();
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Page title="Buyer requests" subtitle="A simple place to log and respond to thoughtful bulk enquiries.">
      <form className="inline-form quote-form" onSubmit={submit}>
        <input data-testid="quote-product-input" placeholder="Product requested" required value={form.product_name} onChange={e => setForm({...form, product_name: e.target.value})}/>
        <input data-testid="quote-quantity-input" type="number" min="1" placeholder="Quantity" required value={form.quantity} onChange={e => setForm({...form, quantity: e.target.value})}/>
        <input data-testid="quote-email-input" type="email" placeholder="Buyer email" required value={form.buyer_email} onChange={e => setForm({...form, buyer_email: e.target.value})}/>
        <button className="primary-btn" data-testid="quote-submit-button" disabled={busy}>{busy ? "Sending…" : "Log request"}</button>
      </form>

      {items.length ? (
        <div className="admin-table" data-testid="quotes-list">
          <div className="admin-row admin-head"><span>Product</span><span>Qty</span><span>Buyer email</span><span>Status</span><span>Date</span></div>
          {items.map(q => (
            <div className="admin-row" key={q.id} data-testid={`quote-${q.id}`}>
              <span>{q.product_name}</span>
              <span>{q.quantity}</span>
              <span>{q.buyer_email}</span>
              <span className="pill amber">{q.status || "New"}</span>
              <span>{new Date(q.created_at).toLocaleDateString()}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state wide">
          <MessageSquareQuote size={30}/>
          <h3>Keep the conversation moving</h3>
          <p>Bulk enquiries submitted here stay connected to the seller workspace for a thoughtful reply.</p>
        </div>
      )}
    </Page>
  );
}
